import { InferType, number, object, string } from 'yup';

export const voucherSchema = object({
  accountUuid: string().required(),
  amount: number().required(),
  description: string().nullable(),
  currency: string().required(),
});

export type voucherSchema = InferType<typeof voucherSchema>;
